<script lang="ts">
import type { HekateDisplayField } from '@onshape/www-inertia';
import CoordinatorProvider from '../coordinator/CoordinatorProvider';
import FieldErrorMessage from './FieldErrorMessage.vue';
import type { SetupContext } from 'vue';

/** Phone input field with country code selector */
export default defineComponent({
  components: {
    FieldErrorMessage,
  },
  props: {
    field: {
      required: true,
      type: Object as unknown as () => HekateDisplayField,
    },
    modelValue: {
      required: true,
      type: String,
    },
  },
  emits: ['blur', 'focus', 'update:modelValue'],
  setup(props: { modelValue: string; field: HekateDisplayField }, context: SetupContext) {
    const { field, modelValue } = toRefs(props);
    return CoordinatorProvider.get().ageVerificationField({
      field,
      modelValue,
      context,
    });
  },
});
</script>

<template>
  <div class="field-age-verification field-container">
    <div
      :class="{
        'field-content': true,
      }"
    >
      <div class="date-wrapper relative mx-auto mt-8 w-fit">
        <h3
          :class="{
            'text-gray mb-4 text-center text-lg': true,
          }"
        >
          My Birthdate is:
        </h3>
        <!-- Custom UI -->
        <div class="date-display flex w-full items-center gap-4">
          <div class="flex grow flex-col">
            <span class="text-lg">Month</span>
            <div
              :class="{
                'field-content-is-errored': mmInput.isErrored,
                'field-content-is-validated': mmInput.isValid,
              }"
            >
              <input
                v-model="mm"
                :class="{ 'month-display mb-0': true }"
                @blur="cleanOnBlur"
              />
            </div>

            <span class="text-gray pb-3 text-xs">mm</span>
          </div>

          <div class="flex grow flex-col">
            <span class="text-lg">Day</span>
            <div
              :class="{
                'field-content-is-errored': ddInput.isErrored,
                'field-content-is-validated': ddInput.isValid,
              }"
            >
              <input
                v-model="dd"
                :class="{ 'day-display mb-0': true }"
                @blur="cleanOnBlur"
              />
            </div>

            <span class="text-gray pb-3 text-xs">dd</span>
          </div>

          <div class="flex grow flex-col">
            <span class="text-lg">Year</span>
            <div
              :class="{
                'field-content-is-errored': yyyyInput.isErrored,
                'field-content-is-validated': yyyyInput.isValid,
              }"
            >
              <input
                v-model="yyyy"
                :class="{ 'year-display mb-0': true }"
                @blur="cleanOnBlur"
              />
            </div>
            <span class="text-gray pb-3 text-xs">yyyy</span>
          </div>
        </div>
      </div>
      <field-error-message :messages="field.errorMessages" />
    </div>
  </div>
</template>
<style lang="scss">
@use '../../../style/vars.scss' as vars;
.text-gray {
  color: #828282;
}
.field-age-verification .hekate-error-message {
  border-top: 1px solid vars.$color-error;
}
</style>
